import React from 'react'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import { Popover, Icon } from 'antd'
import styles from './index.scss'
import UserCenterButton from '../UserCenterButton'
import MessageNotification from '../MessageNotification'
import AppImg from 'assets/images/app.png'

export interface IUserOperatorProps extends RouteComponentProps<any> {
  userStore?: IUserStore.UserStore
}

@inject('userStore')
@observer
class UserOperator extends React.Component<IUserOperatorProps> {
  render() {
    return (
      <div className={styles.userOperator}>
        <div className={styles.left}>
          <Popover
            placement="bottom"
            content={<img className={styles.qrcode} src={AppImg} alt="app" />}
          >
            <div className={styles.app}>
              <Icon style={{ fontSize: 18, color: '#666' }} type="mobile" />
            </div>
          </Popover>
        </div>
        <div className={styles.left}>
          <MessageNotification count={this.props.userStore.userInfo.unanswer} />
        </div>
        <div>
          <UserCenterButton {...this.props} />
        </div>
      </div>
    )
  }
}

export default withRouter(UserOperator)
